export enum InPossessionAttribute {
  KeyPass = 840,
}
